import { type ReactElement } from 'react';

export function FRMPolicySearch(): ReactElement {
  return <div />;
}
